<template>
  <v-row>
    <v-col cols="4">
      <div>
        Service
      </div>
      <div>
        {{ token.provider.toUpperCase() }}
      </div>
    </v-col>

    <v-col cols="4">
      <div>
        Connection ID
      </div>
      <div>
        {{ token.id }}
      </div>
    </v-col>

    <v-col cols="4">
      <div>
        User ID
      </div>
      <div>
        {{ token.user_id }}
      </div>
    </v-col>

    <v-col cols="12"
           v-if="token.instance_base_url">
      <div>
        Instance URL
      </div>
      <div>
        {{ token.instance_base_url }}
      </div>
    </v-col>

    <v-col cols="6">
      <div>
        Created
      </div>
      <div>
        {{ token.created_at | datetime('YYYY-MM-DD @ h:mm a') }}
      </div>
    </v-col>

    <v-col cols="6">
      <div>
        Expires
      </div>
      <div v-if="token.expires_at">
        {{ token.expires_at | datetime('YYYY-MM-DD @ h:mm a') }}
      </div>
      <div v-else>
        Never
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    token: {
      type: Object,
      required: true,
    }
  }
}
</script>
